module.exports = __webpack_public_path__ + "static/media/levelOn04.9bbd0dfe.svg";